<template>
  <div class="dashboard-container">
    <!-- Header / Date Filter -->
    <div class="header-box">
      <img class="tt" src="./images/tt.png" alt="logo" />
      <div class="dashboard-header">
        <el-date-picker
          v-model="dateRange.data"
          type="daterange"
          range-separator="→"
          :start-placeholder="$lang('开始日期')"
          :end-placeholder="$lang('结束日期')"
          size="small"
          class="date-picker"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          :clearable="false"
          :append-to-body="false"
        >
        </el-date-picker>
      </div>

      <!-- Status Flow (Top Cards) -->
      <status-flow />
    </div>

    <div class="content-box">
      <!-- Middle Section -->
      <el-row :gutter="10" class="middle-section" type="flex">
        <el-col :span="16">
          <shipment-analysis />
        </el-col>
        <el-col :span="8">
          <quick-actions />
        </el-col>
      </el-row>

      <!-- Bottom Section -->
      <el-row :gutter="10" class="bottom-section" type="flex">
        <el-col :span="8">
          <order-ratio />
        </el-col>
        <el-col :span="8">
          <problem-distribution />
        </el-col>
        <el-col :span="4">
          <waybill-inventory />
        </el-col>
        <el-col :span="4">
          <operation-manual />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import StatusFlow from './components/StatusFlow'
import ShipmentAnalysis from './components/ShipmentAnalysis'
import QuickActions from './components/QuickActions'
import OrderRatio from './components/OrderRatio'
import ProblemDistribution from './components/ProblemDistribution'
import WaybillInventory from './components/WaybillInventory'
import OperationManual from './components/OperationManual'
import dayjs from 'dayjs'

export default {
  provide() {
    return {
      dateRange: this.dateRange,
    }
  },
  name: 'Dashboard',
  components: {
    StatusFlow,
    ShipmentAnalysis,
    QuickActions,
    OrderRatio,
    ProblemDistribution,
    WaybillInventory,
    OperationManual,
  },
  data() {
    return {
      dateRange: {
        data: [new Date(), new Date()],
      },
      rangeAnchor: null,
      pickerOptions: {
        onPick: ({ minDate, maxDate }) => {
          this.rangeAnchor = maxDate ? null : minDate || maxDate || null
        },
        disabledDate: (time) => {
          const t = time.getTime()
          const todayEnd = dayjs().endOf('day').toDate().getTime()
          if (t > todayEnd) return true
          if (this.rangeAnchor) {
            const startLimit = dayjs(this.rangeAnchor).subtract(1, 'month').startOf('day').toDate().getTime()
            const endLimit = dayjs(this.rangeAnchor).add(1, 'month').endOf('day').toDate().getTime()
            if (t < startLimit || t > endLimit) return true
          }
          return false
        },
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  * {
    box-sizing: border-box;
  }
  .header-box {
    background-image: url('./images/header_bg.png');
    background-size: 100% 100%;
    padding: 20px;
    position: relative;
    .tt {
      position: absolute;
      right: 15%;
      top: 0;
      height: 100%;
    }
  }
  .content-box {
    padding: 20px;
    padding-top: 0;
    background-color: #f0f2f5;
  }

  .dashboard-header {
    margin-bottom: 20px;
    .date-picker {
      background: #fff;
      border-radius: 20px;
      width: 300px;
      margin-bottom: 40px;
    }
  }

  .middle-section {
    margin-bottom: 10px;
    // Ensure equal height columns
    display: flex;
    flex-wrap: wrap;
    height: 418px;

    // Fix for Element UI row flex issue if needed, but usually OK.
    // However, to make inner components stretch, we need them to be height: 100%
  }

  .bottom-section {
    display: flex;
    flex-wrap: wrap;
    height: 260px;
  }
}
</style>
